// Banner e Carosel
$(document).ready(function() {
    var olwSlider = $('.olw-slider');
    olwSlider.owlCarousel({
        items:1,
        loop:true,
        autoplay:true,
        dotsEach:true,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        responsiveClass:true,
        animateOut: 'fadeOut',
    });

    var owlProducts = $('#owl-products');
    owlProducts.owlCarousel({
        loop:true,
        autoplay:true,
        dotsEach:true,
        autoplayTimeout:2000,
        autoplayHoverPause:true,
        responsiveClass:true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 4
            }
        }
    });
});

// Animação Nav Fixo
var nav = $('header');
var slider = $('#slider');
var scrolled = false;

$(window).scroll(function () {

    if (300 < $(window).scrollTop() && !scrolled) {
        nav.addClass('fixed-top').animate({ top: '0px' });
        slider.addClass('marginNav');
        scrolled = true;
    }

    if (2 > $(window).scrollTop() && scrolled) {
       //animates it out of view
       nav.animate({ top: '-97px' });
       //sets it back to default style
        setTimeout(function(){
           nav.removeClass('fixed-top');
           slider.removeClass('marginNav');
        },1);
        scrolled = false;
    }
});

// Animação rolagem da página
$('a[href^="#"]').on('click', function(e) {
	e.preventDefault();
	var id = $(this).attr('href'),
			targetOffset = $(id).offset().top;

	$('html, body').animate({
		scrollTop: targetOffset - 97
	}, 900);
});

// Filtro repre AJAX
function ajax(config) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', config.url, true);

    xhr.onload = e => {
        if(xhr.status === 200) {
            config.sucesso(xhr.response);
        } else if(xhr.status >= 400) {
            config.erro({
                codigo: xhr.status,
                texto: xhr.statusText
            });
        }
    }

    xhr.send();
}

document.getElementById("uf").onchange = function getEstado(){
    let select = document.querySelector('#uf');
    let option = select.options[select.selectedIndex].value;

    let repre = document.querySelector('.body-result');
    repre.innerHTML = '';

    ajax({
        url: 'getRepres/' + option,
        sucesso(response) {
            let data = JSON.parse(response);

            if (data.length == 0) {
                semRepre()
            } else {
                listaRepre(data);
            }
        },
        erro(e){
            alert('Erro!');
        }
    });

    let sel = document.querySelector('.selecione').style.display = 'none';
}

function semRepre() {
    let liRepre = document.createElement('div');
    liRepre.className = 'repreCard danger';
    liRepre.innerHTML += '<h3>Ops! Não temos representante da sua região.</h3>';
    liRepre.innerHTML += '<p>Mas não se preocupe, podemos te atender na Matriz.</p>';
    liRepre.innerHTML += '<p class="fone"><span>Fone:</span> +55 19 99767-6634</p>';
    liRepre.innerHTML += '<p class="email"><span>Email:</span> vendas2@dieselvia.com.br</p>';

    let ulRepre = document.querySelector('.body-result');
    ulRepre.appendChild(liRepre);
}

function listaRepre(data) {
    let repres = data.map(repre => {
        let liRepre = document.createElement('div');
        liRepre.className = 'repreCard';
        liRepre.innerHTML += '<h3>'+ repre.company +'</h3>';
        liRepre.innerHTML += '<p class="name"><span>Contato:</span> ' + repre.name + '</p>';
        liRepre.innerHTML += '<p class="cidade"><span>Cidade:</span> ' + repre.country + '</p>';
        liRepre.innerHTML += '<p class="fone"><span>Fone:</span> ' + repre.fone + '</p>';
        liRepre.innerHTML += '<p class="email"><span>Email:</span> ' + repre.email + '</p>';

        return liRepre;
    });

    let ulRepre = document.querySelector('.body-result');
    repres.forEach(repre => ulRepre.appendChild(repre));
}
